import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon46: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#FFD147"
        d="M7.02 6.653 8.807.894c.37-1.195 2.016-1.195 2.386 0l1.787 5.76h5.766c1.217 0 1.71 1.59.745 2.321l-4.684 3.566 1.79 5.775c.366 1.177-.948 2.178-1.935 1.426L10 16.196l-4.661 3.547c-.99.75-2.302-.25-1.937-1.427l1.792-5.775L.509 8.975c-.964-.732-.471-2.322.744-2.322H7.02Zm3.218-5.462c-.08-.257-.396-.257-.476 0l-1.896 6.11a.501.501 0 0 1-.478.352H1.253c-.24 0-.353.363-.14.527l4.965 3.777a.5.5 0 0 1 .175.546l-1.896 6.11c-.085.273.186.48.377.334l4.964-3.777a.497.497 0 0 1 .605 0l4.964 3.777c.19.144.46-.061.376-.334l-1.895-6.11a.499.499 0 0 1 .175-.546l4.963-3.778c.215-.163.102-.526-.14-.526H12.61a.5.5 0 0 1-.477-.352l-1.896-6.11Z"
      />
    </Svg>
  )
}
